var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidorovaMarie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F6F7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0078 26.25C11.3672 26.25 10.0677 25.724 9.10938 24.6719C8.15104 23.6146 7.67188 22.1771 7.67188 20.3594C7.67188 18.5469 8.15365 17.112 9.11719 16.0547C10.0755 15.0026 11.3724 14.4766 13.0078 14.4766C14.3255 14.4766 15.4401 14.8516 16.3516 15.6016C17.263 16.3568 17.7943 17.3333 17.9453 18.5312H15.625C15.474 17.9115 15.1641 17.4141 14.6953 17.0391C14.2161 16.6693 13.6536 16.4844 13.0078 16.4844C12.1172 16.4844 11.4089 16.8307 10.8828 17.5234C10.3516 18.2214 10.0859 19.1641 10.0859 20.3516C10.0859 21.5547 10.349 22.5026 10.875 23.1953C11.401 23.8932 12.1146 24.2422 13.0156 24.2422C13.6771 24.2422 14.2396 24.0703 14.7031 23.7266C15.1615 23.388 15.4714 22.9167 15.6328 22.3125H17.9531C17.7708 23.5208 17.237 24.4766 16.3516 25.1797C15.4609 25.8932 14.3464 26.25 13.0078 26.25ZM31.5078 26H29.4062V18.3906H29.3438L26.2812 25.8906H24.7969L21.7344 18.3906H21.6719V26H19.5703V14.7266H22.3047L25.5078 22.7188H25.5703L28.7734 14.7266H31.5078V26Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidorovaMarie);
export default __webpack_public_path__ + "static/media/SidorovaMarie.f3ac04dc86fe3fc0b7ef8f205f40d0bb.svg";
export { ForwardRef as ReactComponent };